import service from "../api/services/healthService";

export default {
    namespaced: true,
    state: {
        selectedSubjectData: null,
        selectedChapter: null
    },
    getters: {
        selectedSubjectData(state) {
            return state.selectedSubjectData
        },
        selectedChapter(state) {
            return state.selectedChapter
        },
    },
    mutations: {
        setSelectedSubjectData(state, payload) {
            state.selectedSubjectData = payload;
        },
        setSelectedChapter(state, payload) {
            state.selectedChapter = payload;
        }
    },
    actions: {
        setSelectedSubjectData(context, data) {
            context.commit('setSelectedSubjectData', data);
        },
        setSelectedChapter(context, data) {
            context.commit('setSelectedChapter', data);
        },
        getMyHealthData(context, reqData) {
            return service.getMyHealthData(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getLeaderBoardData(context, reqData) {
            return service.getLeaderBoardData(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getHealthData(context, reqData) {
            return service.getHealthData(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
    }
};